/**
 * TotalsSummary - Shared totals section for quotes and invoices
 * PROMPT 40: Financial Documents Unified View Layer
 */
export function TotalsSummary({
  subtotal,
  taxRate,
  taxAmount,
  total,
  amountPaid, // For invoices
  balanceDue, // For invoices
  currencySymbol = "£",
  taxLabel = "Tax",
  primaryColor = "#0d9488",
}) {
  const showPaymentInfo = amountPaid !== undefined && amountPaid > 0;

  return (
    <div className="mt-6 flex justify-end">
      <div className="w-full max-w-xs space-y-2" data-testid="document-totals">
        <div className="flex justify-between py-2 text-sm">
          <span className="text-muted-foreground">Subtotal</span>
          <span className="font-mono font-medium" data-testid="document-subtotal">
            {currencySymbol}{subtotal?.toFixed(2) || "0.00"}
          </span>
        </div>
        <div className="flex justify-between py-2 text-sm border-b border-border">
          <span className="text-muted-foreground">
            {taxLabel} ({taxRate}%)
          </span>
          <span className="font-mono font-medium" data-testid="document-tax">
            {currencySymbol}{taxAmount?.toFixed(2) || "0.00"}
          </span>
        </div>
        <div className="flex justify-between py-3 text-lg font-bold">
          <span className="text-foreground">Total</span>
          <span 
            className="font-mono" 
            style={{ color: primaryColor }} 
            data-testid="document-total"
          >
            {currencySymbol}{total?.toFixed(2) || "0.00"}
          </span>
        </div>
        
        {/* Payment info for invoices */}
        {showPaymentInfo && (
          <>
            <div className="flex justify-between py-2 text-sm border-t border-border">
              <span className="text-muted-foreground">Amount Paid</span>
              <span className="font-mono font-medium text-green-600" data-testid="document-amount-paid">
                {currencySymbol}{amountPaid?.toFixed(2) || "0.00"}
              </span>
            </div>
            <div className="flex justify-between py-2 text-sm font-semibold">
              <span className="text-foreground">Balance Due</span>
              <span 
                className="font-mono" 
                style={{ color: balanceDue > 0 ? '#dc2626' : primaryColor }}
                data-testid="document-balance-due"
              >
                {currencySymbol}{balanceDue?.toFixed(2) || "0.00"}
              </span>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default TotalsSummary;
